import { BROADCAST_EDIT_SOURCES_ORDER } from 'actions/Types';

const initialState = false;

export { initialState };

export default (state = initialState, action) => {
  if (action.type === BROADCAST_EDIT_SOURCES_ORDER) {
    return !state;
  }

  return state;
};
